const ClassNames = {
  BASE: 'tn-events-calendar',
  // TABLE_HEADING: 'tn-events-calendar__table-heading',
};

export default ClassNames;
